import { Decimal } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputDecimal } from '../decimalInput'
import { InputQuantityProps } from './types'

export default function SingleQuantityInput({
  disabled,
  inputId,
  onChange,
  options,
  required,
  value
}: InputQuantityProps) {
  function handleChange(newValue: string) {
    const parsedValue = Number.parseFloat(newValue)

    if (
      Number.isNaN(parsedValue) ||
      !Number.isFinite(parsedValue) ||
      !options?.[0]
    ) {
      return onChange(null)
    }

    onChange({
      value: parsedValue as Decimal,
      system: options[0].system,
      code: options[0].code,
      unit: options[0].display
    })
  }

  return (
    <div className='grid grid-cols-12 gap-2'>
      <div className='col-span-8'>
        <InputDecimal
          id={inputId}
          disabled={disabled}
          name={`${inputId}-quantity`}
          onChange={handleChange}
          required={required}
          value={value?.value?.toString()}
        />
      </div>
      <div className='col-span-4 flex items-center'>
        <span>{options?.[0]?.display ?? options?.[0]?.code}</span>
      </div>
    </div>
  )
}
